export default __webpack_public_path__ + "static/media/serviceImg.201fb192.jpg";